var map = {
	"./365.svg": 2831,
	"./Download.svg": 89871,
	"./Excel.svg": 93727,
	"./Home page.svg": 1747,
	"./Store management.svg": 44627,
	"./Supplier management.svg": 25778,
	"./Tips.svg": 44600,
	"./Toggle.svg": 10076,
	"./activityEdit.svg": 35006,
	"./add.svg": 91262,
	"./back.svg": 23812,
	"./backNew.svg": 41735,
	"./bell.svg": 62541,
	"./camera.svg": 98485,
	"./close.svg": 40314,
	"./close_circle.svg": 20125,
	"./cn.svg": 73067,
	"./confirm.svg": 42503,
	"./copy.svg": 7778,
	"./data_download.svg": 38714,
	"./decrease.svg": 59987,
	"./delete.svg": 15549,
	"./enCn.svg": 43713,
	"./eng.svg": 34883,
	"./fileIcon_excel.svg": 45747,
	"./fileIcon_jpg.svg": 85213,
	"./fileIcon_other.svg": 95289,
	"./fileIcon_pdf.svg": 87330,
	"./fileIcon_png.svg": 73492,
	"./fileIcon_ppt.svg": 39489,
	"./fileIcon_word.svg": 34648,
	"./file_close.svg": 2507,
	"./file_open.svg": 27161,
	"./file_open_mask.svg": 52605,
	"./folder.svg": 40886,
	"./folderCardDelete.svg": 60166,
	"./list.svg": 18833,
	"./location.svg": 23408,
	"./location_sort.svg": 82431,
	"./menu_item1.svg": 24993,
	"./menu_item2.svg": 69462,
	"./menu_item3.svg": 16027,
	"./menu_item4.svg": 77979,
	"./menu_item5.svg": 89668,
	"./menu_item6.svg": 55554,
	"./menu_item7.svg": 58448,
	"./mine.svg": 17621,
	"./more.svg": 43205,
	"./picture.svg": 15288,
	"./qr.svg": 72264,
	"./qrCode.svg": 46289,
	"./repair.svg": 74597,
	"./search.svg": 32938,
	"./setup.svg": 71762,
	"./share.svg": 45124,
	"./shop.svg": 57507,
	"./signature.svg": 38353,
	"./sort.svg": 63624,
	"./sort2.svg": 95909,
	"./sortdown.svg": 28162,
	"./sortup.svg": 84632,
	"./tips2.svg": 64352,
	"./tk_file.svg": 8161,
	"./tk_plus.svg": 833,
	"./tk_search.svg": 85581,
	"./tk_sort.svg": 13553,
	"./tk_sub.svg": 76239,
	"./tk_upload.svg": 81624,
	"./unfold.svg": 88947,
	"./upload.svg": 37716,
	"./user.svg": 35632,
	"./warning.svg": 42991,
	"./wxlogin.svg": 55295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88091;